<template>
  <div class="zenventory-icon" :style="style"></div>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'ZenventoryLogoIcon',
  props: {
    height: VueTypes.string.def('32'),
    width: VueTypes.string.def('32'),
  },
  computed: {
    style() {
      return `width: ${this.width}; height: ${this.height};`;
    },
  },
};
</script>

<style lang="scss">
.prestashop-icon {
  background-image: url('../../images/zenventory.svg');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  display: inline-block;
  height: 64px;
  width: 64px;
}
</style>
